import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from '../Login';
import Home from '../Home';
import Datasources from '../Datasources';
import DatasourceEdit from '../DatasourceEdit';
import Datasource from '../Datasource';
import Table from '../Table';
import TableEdit from '../TableEdit';
import Database from '../Database';
import DatabaseEdit from '../DatabaseEdit';
import UserManagement from '../UserManagement';
import UserPermissionManagement from '../UserPermissionManagement';
import MyProfile from '../MyProfile';
import TagScreen from '../TagScreen';
import Dashboard from '../Dashboard';
import Dashboards from '../Dashboards';
import DashboardEdit from '../DashboardEdit';

import Segments from '../Segments';
import SegmentDetail from '../SegmentDetail';
import SegmentEdit from '../SegmentEdit';

import BusinessPartners from '../BusinessPartner/BusinessPartners';
import ContentTypes from '../Content/ContentTypes';

import ContentAnalysis from '../Analytics/ContentAnalysis';
import AIContentEdit from '../AIContentEdit';

import api from '../../api';

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
//https://medium.com/@pshrmn/a-simple-react-router-v4-tutorial-7f23ff27adf

// For loggin handling, use component={CheckForLogIn}
// This ensure that all the pages required log in will be run AFTER our login logic
// https://medium.com/the-many/adding-login-and-authentication-sections-to-your-react-or-react-native-app-7767fd251bd1

const PrivateRoute = ({component: Component, authed, ...rest}) => {
  return (
    <Route
      {...rest}
      render={(props) => authed === true
        ? <Component {...props} />
        : <Redirect to="/login" />}
    />
  )
}
export default class Main extends React.Component {
  constructor(props) {
    super(props);
    const token = api.getUser();
    if (!token) {
      alert('You must be logged in to use this site');
      this.authed = false;
    }
    else {
      this.authed = true;
    }
  }
  componentDidMount() {
    const token = api.getUser();
    if (!token) {
      alert('You must be logged in to use this site');
      this.authed = false;
    }
    else {
      this.authed = true;
    }
  }
  render() {
    const authed = this.authed;
    return (
      <main>
        <Switch>
          <Route exact path='/login' component={Login}/>
          <PrivateRoute authed={authed} exact path='/' component={Home}/>

          <PrivateRoute authed={authed} exact path='/segments' component={Segments}/>
          <PrivateRoute authed={authed} exact path='/segments/create' component={SegmentEdit}/>
          <PrivateRoute authed={authed} exact path='/segment/:segment_id' component={SegmentDetail}/>
          <PrivateRoute authed={authed} exact path='/segment/:segment_id/edit' component={SegmentEdit}/>

          <PrivateRoute authed={authed} exact path='/table/:table_id' component={Table}/>
          <PrivateRoute authed={authed} exact path='/table/:table_id/field/:field_id' component={Table}/>
          <PrivateRoute authed={authed} exact path='/table/:table_id/edit' component={TableEdit}/>

          <PrivateRoute authed={authed} exact path='/database/:database_id' component={Database}/>
          <PrivateRoute authed={authed} exact path='/database/:database_id/table/:table_id' component={Database}/>
          <PrivateRoute authed={authed} exact path='/database/:database_id/edit' component={DatabaseEdit}/>

          <PrivateRoute authed={authed} exact path='/datasources' component={Datasources}/>
          <PrivateRoute authed={authed} exact path='/datasource/:datasource_id' component={Datasource}/>
          <PrivateRoute authed={authed} exact path='/datasource/:datasource_id/edit' component={DatasourceEdit}/>

          <PrivateRoute authed={authed} exact path='/users' component={UserManagement}/>
          <PrivateRoute authed={authed} exact path='/user/:user_id/permissions' component={UserPermissionManagement}/>
          <PrivateRoute authed={authed} exact path='/me' component={MyProfile}/>

          <PrivateRoute authed={authed} exact path='/business_partners' component={BusinessPartners}/>

          <PrivateRoute authed={authed} exact path='/tag/:tag_id' component={TagScreen}/>

          <PrivateRoute authed={authed} exact path='/dashboards' component={Dashboards}/>
          <PrivateRoute authed={authed} exact path='/dashboard/:dashboard_id' component={Dashboard}/>
          <PrivateRoute authed={authed} exact path='/create-dashboard' component={DashboardEdit}/>
          <PrivateRoute authed={authed} exact path='/dashboard/:dashboard_id/edit' component={DashboardEdit}/>

          <PrivateRoute authed={authed} exact path='/content_types' component={ContentTypes}/>

          <PrivateRoute authed={authed} exact path='/ai/content_edit' component={AIContentEdit}/>

          <PrivateRoute authed={authed} exact path='/analytics/content' component={ContentAnalysis}/>
          <PrivateRoute authed={authed} exact path='/analytics/content/:external_content_id' component={ContentAnalysis}/>
        </Switch>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          pauseOnHover
        />
      </main>
    );
  }
  
};



// WEBPACK FOOTER //
// ./src/pages/Main/index.js